var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBagBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33955",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6384 20.5003H6.29055C3.22419 20.5003 0.871786 19.3927 1.53998 14.9351L2.31801 8.89387C2.72991 6.66962 4.14867 5.81836 5.39352 5.81836H15.572C16.8352 5.81836 18.1716 6.73369 18.6475 8.89387L19.4256 14.9351C19.9931 18.8893 17.7047 20.5003 14.6384 20.5003Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33956",
    d: "M14.7762 5.59873C14.7762 3.21265 12.8419 1.27836 10.4559 1.27836V1.27836C9.30686 1.27349 8.20325 1.72652 7.38906 2.53727C6.57487 3.34803 6.11718 4.44971 6.11719 5.59873H6.11719",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_192",
    d: "M13.422 10.1022H13.3762",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_193",
    d: "M7.58992 10.1022H7.54416",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagBlackIcon);
export default __webpack_public_path__ + "static/media/bag-black-icon.77e1081319449dc6b6595eb5789517ca.svg";
export { ForwardRef as ReactComponent };